import Pager from "@/helpers/Pager";

export default {
    namespaced: true,
    state: {
        pager: new Pager(1, undefined, 'DateCreatedUtc', 'DESC')
    }
};

